export default {"src":"/_next/static/media/profile-powers.e0e9c275.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};